import React, { useEffect, useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { onboardingService } from "../../services/onboarding/onboardingService";
import OnboardingWizard from "../onboarding/OnboardingWizard";

interface OnboardingCheckProps {
  children: React.ReactNode;
}

const OnboardingCheck: React.FC<OnboardingCheckProps> = ({ children }) => {
  const { user } = useAuth();
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkOnboarding = async () => {
      if (user) {
        try {
          const status = await onboardingService.getOnboardingStatus();
          // Check if user has previously dismissed the onboarding
          const hasSeenOnboarding = localStorage.getItem(
            `onboarding_dismissed_${user.id}`
          );

          // Show onboarding only if user hasn't completed it AND hasn't dismissed it before
          if (!status.hasCompletedOnboarding && !hasSeenOnboarding) {
            setShowOnboarding(true);
          }
        } catch (error) {
          console.error("Error checking onboarding status:", error);
        }
      }
      setLoading(false);
    };

    checkOnboarding();
  }, [user]);

  const handleOnboardingComplete = () => {
    setShowOnboarding(false);
    // Mark as dismissed in localStorage so it doesn't show again
    if (user) {
      localStorage.setItem(`onboarding_dismissed_${user.id}`, "true");
    }
    // Refresh onboarding status
    onboardingService.getOnboardingStatus();
  };

  const handleOnboardingSkip = () => {
    setShowOnboarding(false);
    // Mark as dismissed in localStorage so it doesn't show again
    if (user) {
      localStorage.setItem(`onboarding_dismissed_${user.id}`, "true");
    }
  };

  if (loading) {
    return <>{children}</>;
  }

  return (
    <>
      {children}
      {user && (
        <OnboardingWizard
          open={showOnboarding}
          onComplete={handleOnboardingComplete}
          onSkip={handleOnboardingSkip}
        />
      )}
    </>
  );
};

export default OnboardingCheck;
